/* eslint-disable max-len */
export default {
  welcome: 'Bienvenido a Oyster',
  status: { ready: 'Listo para procesar', notReady: 'No se puede procesar' },
  continue: 'Continuar',
  cancel: 'Cancelar operación',
  send: 'Enviar',
  stepper: {
    validation: {
      title: 'Validación de pagos',
      subtitle:
        'Selecciona los pagos que deseas dispersar. Cuando estés listo, haz clic en continuar.',
      header: 'Pagos seleccionados para dispersar',
      totalAmount: 'Monto total a dispersar',
      amountInvalid: 'El importe requiere ser en moneda nacional',
      clabeInvalid: 'Es requerido proporcionar CLABE interbancaria',
    },
    fundingRequest: {
      title: 'Resumen y Fondeo',
      titleSection: 'Solicitud y aprobación de fondeo',
      subtitle: 'Sigue las instrucciones para pagar mediante SPEI.',
      header: 'Resumen de operación',
      totalAmount: 'Monto total',
    },
    fundingRequestVariant: {
      title: 'Resumen y Fondeo',
      titleSection: 'Solicitud y aprobación de fondeo',
      subtitle:
        'Haz recibido una solicitud de fondeo, ocupa los datos bancarios mostrados a continuación para completarla, o bien, reenvía esta solicitud a alguien más',
    },
    operationInProcess: {
      title: 'Dispersión en proceso',
      subtitle:
        'En esta página se mostrarán las dispersiones completadas y aquellas que no pudieron ser realizadas correctamente (si aplica). \nFavor de actualizar la página constantemente para ver nuevas operaciones.',
    },
    operationCompleted: {
      title: 'Dispersión completada',
      subtitle:
        'Se muestra el listado de transacciones realizadas con exito y aquellas que no pudieron ser realizadas (si aplica)',
      completed: 'Dispersión completada',
    },
  },
  operationCanceled: {
    title: 'Operación cancelada',
    subtitle:
      'La operación fue cancelada, para realizar una operación nueva, por favor, cierra esta ventana y genera una nueva solicitud',
  },
  bankData: {
    title: 'Instrucciones pago con SPEI',
    referenceInfo:
      'Utilizar la referencia correcta desde tu banca en linea es indispensable para asegurar el pago exitoso. Asegúrate de ingresarla correctamente en el campo “Referencia” desde tu banca.',
    referenece: 'Referencia',
    clabe: 'CLABE',
    beneficiary: 'Beneficiario',
    bank: 'Banco',
  },
  fundingRequest: {
    shareLink: 'Copia y comparte tu link',
    sendEmail: 'Envía por email',
    helpData: 'Recuerda separar múltiples correos por comas (,)',
    wrongApprover: '¿Alguien más debe realizar la aprobación y el fondeo?',
    resendRequest: 'Reenviar solicitud',
  },
  operationCompleted: {
    cardOperationsTitle: {
      success: 'Dispersiones realizadas',
      unsuccessful: 'Dispersiones no realizadas',
    },
    cardOperationsDescription: {
      success: 'Se muestran los pagos dispersados correctamente',
      unsuccessful: 'Se muestran los pagos que no pudieron ser dispersados',
    },
    total: {
      dispersed: 'Total dispersado',
      undispersed: 'Total no dispersado',
    },
    helpText: '*Esta cantidad será reembolsada a la cuenta de origen en menos de 24 hrs',
  },
  cancelModal: {
    title: '¿Cancelar operación?',
    description:
      'Este proceso no se puede revertir, si cancelas, deberás comenzar el proceso nuevamente',
    confirmButton: 'Si',
    cancelButton: 'No',
  },
  sendRequestModal: {
    title: '¿Reenviar esta solicitud?',
    description: 'Volverás a la pantalla para poder reenviar esta operación a alguien más',
    confirmButton: 'Reenviar',
    cancelButton: 'Cancelar',
  },
  toast: {
    error: { title: 'Error', unknown: 'Intenta de nuevo' },
    success: {
      title: 'Listo',
      sendEmail: 'Solicitud enviada',
      copyUrl: 'Enlace copiado',
      copyText: 'Texto copiado',
    },
  },
  loader: {
    title: 'Estamos cargando la información',
  },
  tableHeaders: {
    businessName: 'Vendor',
    clabe: 'CLABE',
    refNumber: '# Factura',
    paymentId: 'Estatus',
    amount: 'Monto',
    vendor: 'Vendedor',
  },
  footer: {
    ourSolutions: 'Nuestras soluciones',
    porCobrar: 'PorCobrar',
    buyer: 'Buyer',
    vendorplace: 'Vendorplace',
    legal: 'Legal',
    termsAndConditions: 'Términos y condiciones',
    privacyPolicies: 'Políticas de privacidad',
    rights: 'Oyster© un producto de Yaydoo© 2023 | Todos los derechos reservados',
    findUs: 'Encuentranos en:',
  },
  columnsName: {
    category: 'Categoría',
    type: 'Tipo',
    class: 'Clase',
    department: 'Departamento',
    project: 'Proyecto',
    payableType: 'AP',
    payableSubType: 'APST',
    paymentConcept: 'Concepto',
    reference: 'Referencia',
    provider: 'Proveedor',
    clabe: 'Clabe',
  },
};
